import Add from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import React from "react";
import { useFieldArray, useFormContext } from "react-hook-form";

interface ArrayFieldProps {
  extractionId: string;
  FormField: React.FC<{
    extractionId: string;
    extractionPath?: string;
    label?: string;
    key?: string;
    remove?: Function;
  }>;
  getDefaultValue: Function;
}

const ArrayField: React.FC<ArrayFieldProps> = ({
  extractionId,
  FormField,
  getDefaultValue,
}) => {
  const { control } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: `extraction.${extractionId}.value`,
  });

  return (
    <Stack spacing={2}>
      {fields.map((_field, index) => {
        return (
          <Paper key={_field.id} variant="outlined" sx={{ p: 2 }}>
            <FormField
              extractionId={extractionId}
              extractionPath={`${index}`}
              remove={() => remove(index)}
            />
          </Paper>
        );
      })}
      <Button
        onClick={() => {
          append(getDefaultValue());
        }}
        className="rounded-full"
        aria-label="Add an element"
        variant="outlined"
      >
        <Add fontSize="small" />
      </Button>
    </Stack>
  );
};

export default ArrayField;
